export default __webpack_public_path__ + "static/media/Home_HeaderFade.3bfbf10a.jpg";